const enterpriseInfoRegister = r => require.ensure([], () => r(require('@/page/enterpriseInfoRegister/enterpriseInfoRegister.vue')), 'enterpriseInfoRegister');
const enterpriseRegisterList = r => require.ensure([], () => r(require('@/page/enterpriseInfoRegister/enterpriseRegisterList.vue')), 'enterpriseRegisterList');
const enterpriseInfoRegDetail = r => require.ensure([], () => r(require('@/page/enterpriseInfoRegister/enterpriseInfoRegDetail.vue')), 'enterpriseInfoRegDetail');
const enterpriseRegExamine = r => require.ensure([], () => r(require('@/page/enterpriseInfoRegister/enterpriseRegExamine.vue')), 'enterpriseRegExamine');

const enterpiseInfoRegisterRouter = {
    path: '',
    name: '企业信息登记',
    component: enterpriseInfoRegister,
    meta: {
        icon: 'expertInfo',
        right: [],
        isShowMenu: true,
        keepAlive: false,
    },
    children: [
        {
            path: '/enterpriseRegisterList',
            component: enterpriseRegisterList,
            name: '企业信息登记',
            meta: {
                right: ['企业信息登记'],
                isShowMenu: true,
            },
        },
        {
            path: '/enterpriseInfoRegDetail',
            component: enterpriseInfoRegDetail,
            name: '企业信息登记填报',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive:false
            },
        },
        {
            path: '/enterpriseInfoRegDetailExamine',
            component: enterpriseInfoRegDetail,
            name: '企业信息登记审核',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive:false
            },
        },
        {
            path: '/enterpriseInfoDetail',
            component: enterpriseInfoRegDetail,
            name: '物业企业详情',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive:false
            },
        },
        {
            path: '/enterpriseRegExamine',
            component: enterpriseRegExamine,
            name: '企业信息审核',
            meta: {
                right: ['企业信息审核'],
                isShowMenu: true,
                keepAlive:false
            },
        }
    ]
};
export default enterpiseInfoRegisterRouter;